import React from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { GlobalOutlined } from '@ant-design/icons';

const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();

  const handleLanguageChange = (value: string) => {
    i18n.changeLanguage(value);
    localStorage.setItem('language', value);
  };

  const languageOptions = [
    {
      value: 'en',
      label: t('language.english'),
    },
    {
      value: 'sq',
      label: t('language.albanian'),
    },
    {
      value: 'de',
      label: t('language.german'),
    },
  ];

  return (
    <Select
      value={i18n.language}
      onChange={handleLanguageChange}
      options={languageOptions}
      style={{ width: 120 }}
      suffixIcon={<GlobalOutlined />}
      title={t('language.switchLanguage')}
    />
  );
};

export default LanguageSwitcher; 